import config from "../config.js"
import Admin from "../models/Admin.js"
import Client from "../models/Client.js"
import Profile from "../models/Profile.js"
import Axios from "axios";

const PROFILE_API = config.API_URL + '/profile';
const ADMINS_API = config.API_URL + '/admins';
const CLIENTS_API = config.API_URL + '/clients';
const LOGIN_API = config.API_URL + '/login';
const PASSWORD_RESET_API = config.API_URL + '/resetPassword';

export default {

  getMyRole() {
    return localStorage.getItem('my_role');
  },

  getCurrentUser() {
    return Axios
      .get(PROFILE_API)
      .then(response => {
        let profile = new Profile(response.data);
        localStorage.setItem('my_role', profile.role);
        return profile;
      });
  },

  updateProfile(profile) {
    return Axios
      .put(PROFILE_API, profile)
  },

  listAdmins() {
    return Axios
      .get(ADMINS_API)
      .then(response => {
        return response.data.map(u => new Admin(u));
      });
  },

  getAdmin(userId) {
    return Axios
      .get(ADMINS_API + "/" + userId)
      .then(response => {
        return new Admin(response.data);
      });
  },

  createAdmin(user) {
    return Axios
      .post(ADMINS_API, user)
  },

  updateAdmin(user) {
    return Axios
      .put(ADMINS_API + "/" + user.id, user)
  },

  deleteAdmin(userId, replacementId) {
    return Axios
      .delete(ADMINS_API + "/" + userId + "/replacement/" + replacementId)
  },

  listClients() {
    return Axios
      .get(CLIENTS_API)
      .then(response => {
        return response.data.map(u => new Client(u));
      });
  },

  getClient(userId) {
    return Axios
      .get(CLIENTS_API + "/" + userId)
      .then(response => {
        return new Client(response.data);
      });
  },

  createClient(user) {
    return Axios
      .post(CLIENTS_API, user)
  },

  updateClient(user) {
    return Axios
      .put(CLIENTS_API + "/" + user.id, user)
  },

  deleteClient(userId) {
    return Axios
      .delete(CLIENTS_API + "/" + userId)
  },

  login(login) {
    this.logout();
    return Axios
      .post(LOGIN_API, {
        email: login.email,
        password: login.password
      })
      .then(function (response) {
        localStorage.setItem('token', response.headers.authorization);
      })
  },

  logout() {
    localStorage.removeItem("my_role");
    localStorage.removeItem("token");
  },

  isLogged() {
    return localStorage.getItem('token') !== null;
  },

  requestPasswordReset(email, url) {
    return Axios
      .post(PASSWORD_RESET_API, {
        email: email,
        url: url
      })
  },

  resetPassword(token, newPassword, newPasswordConfirm) {
    let config = {
      headers: {
        "Authorization": `Bearer ${token}`
      }
    };
    return Axios
      .put(PASSWORD_RESET_API, {
        passwordNew: newPassword,
        passwordNewConfirm: newPasswordConfirm
      }, config).then(response => {
        localStorage.setItem('token',response.headers.authorization)
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/userService.js